var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"full-width",staticStyle:{"border":"0"},attrs:{"src":_vm.parsedUrl,"frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }